import { render, staticRenderFns } from "./ViewTeam.vue?vue&type=template&id=e75ef6f2"
import script from "./ViewTeam.vue?vue&type=script&lang=js"
export * from "./ViewTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports